import { type ReactNode } from 'react';

// Types ----
type DescriptionListProps = {
  children: ReactNode;
};

// Component ----

function DescriptionList({ children }: DescriptionListProps) {
  return (
    <div className="border-t border-gray-100">
      <dl className="divide-y divide-gray-100">{children}</dl>
    </div>
  );
}

// Export ----

export default DescriptionList;
